import { Component, OnInit, Input, Self, Optional, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatInput, MatDatepickerInput } from '@angular/material';
import { NgControl, ControlValueAccessor, DefaultValueAccessor } from '@angular/forms';
import { ValidationMessageService, FieldConventionService } from 'src/app/stp/stp-app/forms';

@Component({
  selector: 'stp-date-picker',
  templateUrl: './date-picker.component.html'
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() required: boolean;
  @Input() hint?: string;
  @Input() errorMessage?: string;
  @Input() min = null;
  @Input() max = null;

  @ViewChild(MatInput) private matInput: MatInput;
  @ViewChild(MatDatepickerInput) private matDatepickerInput: MatDatepickerInput<any>;

  constructor(
    @Optional() @Self() private ngControl: NgControl,
    private fieldConventionService: FieldConventionService,
    private validationMessageService: ValidationMessageService
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    this.matInput.ngControl = this.ngControl;

    if (!this.label) {
      this.label = this.fieldConventionService.getDefaultLabel(this.ngControl.name);
    }
  }

  writeValue(obj: any): void {
    this.matDatepickerInput.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.matDatepickerInput.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.matDatepickerInput.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.matDatepickerInput.setDisabledState(isDisabled);
  }

  getErrorMessage() {
    if (this.errorMessage) {
      return this.errorMessage;
    }

    return this.validationMessageService.getMessage(this.label, this.ngControl.errors);
  }
}
